<div class="paginator-wrapper" [ngStyle]="{ visibility: length ? 'visible' : 'hidden' }">
  <mat-paginator
    [disabled]="disabled"
    [length]="length"
    [pageIndex]="page - 1"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions || defaultPageSizeOptions"
    [showFirstLastButtons]="true"
    [hidePageSize]="labelHidden"
    (page)="onPaginationChange($event)"
  ></mat-paginator>
</div>
